import * as React from 'react';
import {
  SortingState, EditingState, PagingState,
  IntegratedPaging, IntegratedSorting,FilteringState,IntegratedFiltering
} from '@devexpress/dx-react-grid';

import {
  Grid,
  Table, TableHeaderRow, TableEditRow, TableEditColumn,TableFilterRow,
  PagingPanel, DragDropProvider, TableColumnReordering,TableColumnResizing
} from '@devexpress/dx-react-grid-material-ui';

import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TableCell from '@material-ui/core/TableCell';
import LoaderButton from "../../components/LoaderButton";

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import { withStyles } from '@material-ui/core/styles';

import FormLabel from '@material-ui/core/FormLabel';

import { API } from "aws-amplify";
import { s3DeleteThumbnail } from '../../libs/awsLib';


const styles = theme => ({
  lookupEditCell: {
    paddingTop: theme.spacing.unit * 0.875,
    paddingRight: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
  },
  dialog: {
    width: 'calc(100% - 16px)',
  },
  inputRoot: {
    width: '100%',
  },
});

const AddButton = () => (
  <div style={{ textAlign: 'center' }}>
    <LoaderButton
                  block
                  bsStyle="primary"
                  bsSize="small"
                  text="Add +"
                  href = "/topics/new"
                  style={ {backgroundColor: '#00BCD4'} }
                  />
  </div>
);

const EditButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Edit row">
    <EditIcon />
  </IconButton>
);

const DeleteButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Delete row">
    <DeleteIcon />
  </IconButton>
);

const CommitButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Save changes">
    <SaveIcon />
  </IconButton>
);

const CancelButton = ({ onExecute }) => (
  <IconButton color="secondary" onClick={onExecute} title="Cancel changes">
    <CancelIcon />
  </IconButton>
);

const commandComponents = {
  add: AddButton,
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton,
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'auto',
    },
  },
};



const Command = ({ id, onExecute }) => {
  const CommandButton = commandComponents[id];
  return (
    <CommandButton
      onExecute={onExecute}
    />
  );
};


var availableValues = {};

const LookupEditCellBase = ({
  availableColumnValues,value, onValueChange, classes,
}) => (
  <TableCell
    className={classes.lookupEditCell}
  >
          <Select
            value={value}
            onChange={event => onValueChange(event.target.value)}
            input={(
              <Input
                classes={{ root: classes.inputRoot }}
              />
            )}
            MenuProps={MenuProps}
          >
            {availableColumnValues.map(name => (
              <MenuItem
                key={name}
                value={name}
              >
                {name}
              </MenuItem>
            ))}
          </Select>
  </TableCell>
);
export const LookupEditCell = withStyles(styles, { name: 'topic' })(LookupEditCellBase);

const Cell = (props) => {
  // if (column.name === 'topic') {
  //   return <ProgressBarCell {...props} />;
  // }
  // if (column.name === 'country') {
  //   return <HighlightedCell {...props} />;
  // }
  return <Table.Cell {...props} />;
};

const EditCell = (props) => {
  const { column } = props;
  const availableColumnValues = availableValues[column.name];
  if (availableColumnValues) {
    return <LookupEditCell {...props} availableColumnValues={availableColumnValues}/>;
  }
  return <TableEditRow.Cell {...props} />;
};

const getRowId = row => row.topic;

class Topics extends React.PureComponent  {  
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: 'topic', title: 'Topic' },
        { name: 'category', title: 'Category' },
        { name: 'title', title: 'Title' },
        { name: 'description', title: 'Description' },
        { name: 'image', title: 'Image' },
        { name: 'SDG1', title: 'SDG1' },
        { name: 'SDG2', title: 'SDG2' },
        { name: 'SDG3', title: 'SDG3' },
        { name: 'SDG4', title: 'SDG4' },
        { name: 'SDG5', title: 'SDG5' },
        { name: 'SDG6', title: 'SDG6' },
        { name: 'SDG7', title: 'SDG7' },
        { name: 'SDG8', title: 'SDG8' },
        { name: 'SDG9', title: 'SDG9' },
        { name: 'SDG10', title: 'SDG10' },
        { name: 'SDG11', title: 'SDG11' },
        { name: 'SDG12', title: 'SDG12' },
        { name: 'SDG13', title: 'SDG13' },
        { name: 'SDG14', title: 'SDG14' },
        { name: 'SDG15', title: 'SDG15' },
        { name: 'SDG16', title: 'SDG16' },
        { name: 'SDG17', title: 'SDG17' }
      ],
      rows:[],
      category:[],
      sorting: [],
      editingRowIds: [],
      addedRows: [],
      rowChanges: {},
      currentPage: 0,
      deletingRows: [],
      pageSize: 50,
      pageSizes: [0,50,100],
      columnOrder: ['topic', 'category', 'title', 'description', 'image', 
      'SDG1', 'SDG2',  'SDG3',  'SDG4',  'SDG5',  'SDG6',  'SDG7',  'SDG8',  'SDG9',  'SDG10',  'SDG11',  'SDG12', 
      'SDG13',  'SDG14',  'SDG15',  'SDG16',  'SDG17' ],
      defaultColumnWidths: [
        { columnName: 'topic', width: 200 },
        { columnName: 'category', width:  200 },
        { columnName: 'title', width:  200 },
        { columnName: 'description', width:  200 },
        { columnName: 'image', width:  200 },
        { columnName: 'SDG1', width:  100  },
        { columnName: 'SDG2', width:  100 },
        { columnName: 'SDG3', width:  100 },
        { columnName: 'SDG4', width:  100 },
        { columnName: 'SDG5', width:  100 },
        { columnName: 'SDG6', width:  100 },
        { columnName: 'SDG7', width:  100  },
        { columnName: 'SDG8', width:  100  },
        { columnName: 'SDG9', width:  100 },
        { columnName: 'SDG10', width:  100  },
        { columnName: 'SDG11', width:  100  },
        { columnName: 'SDG12', width:  100  },
        { columnName: 'SDG13', width:  100  },
        { columnName: 'SDG14', width:  100  },
        { columnName: 'SDG15', width:  100  },
        { columnName: 'SDG16', width:  100  },
        { columnName: 'SDG17', width:  100  }
      ],
      open:false

    };

    

    const getStateDeletingRows = () => {
      const { deletingRows } = this.state;
      return deletingRows;
    };
    
    const getStateRows = () => {
      const { rows } = this.state;
      return rows;
    };

    this.handleClose =  open => { this.setState({ open: false });  
    window.location.reload();
    };
    this.changeSorting = sorting => this.setState({ sorting });
    this.changeEditingRowIds = editingRowIds => this.setState({ editingRowIds });
    this.changeAddedRows = addedRows => this.setState({
      addedRows: addedRows.map(row => (Object.keys(row).length ? row : {
        // amount: 0,
        // discount: 0,
        // saleDate: new Date().toISOString().split('T')[0],
        // product: availableValues.product[0],
        // region: availableValues.region[0],
        // customer: availableValues.customer[0],
      })),
    });
    this.changeRowChanges = rowChanges => this.setState({ rowChanges });
    this.changeCurrentPage = currentPage => this.setState({ currentPage });
    this.changePageSize = pageSize => this.setState({ pageSize });
    this.commitChanges = ({ added, changed, deleted }) => {
      let { rows } = this.state;
      if (added) {
        const startingAddedId = rows.length > 0 ? rows[rows.length - 1].id + 1 : 0;
        rows = [
          ...rows,
          ...added.map((row, index) => ({
            id: startingAddedId + index,
            ...row,
          })),
        ];
      }
      if (changed) {
        rows = rows.map(row =>(changed[row.topic] ? { ...row, ...changed[row.topic] } : row));
        this.updateTopic(rows, changed);

      }
      this.setState({ rows, deletingRows: deleted || getStateDeletingRows() });

    };
    // Call POST API to edit the topics table.
    this.updateTopic=async (rows, changedRow)=>{
      var updatedRow=[];

      for(var item in changedRow)
      {
        if(!changedRow[item])
        {
            return;
        }
        if(Object.keys(changedRow[item])==="topic")
        return this.setState({open:true});

      }

       rows.map((row) =>{
        if(changedRow[row.topic] )
        {
          row.SDG1=  row.SDG1? 'Yes':'No'
          row.SDG2=  row.SDG2? 'Yes':'No'
          row.SDG3=  row.SDG3? 'Yes':'No'
          row.SDG4=  row.SDG4? 'Yes':'No'
          row.SDG5=  row.SDG5? 'Yes':'No'
          row.SDG6=  row.SDG6? 'Yes':'No'
          row.SDG7=  row.SDG7? 'Yes':'No'
          row.SDG8=  row.SDG8? 'Yes':'No'
          row.SDG9=  row.SDG9? 'Yes':'No'
          row.SDG10= row.SDG10? 'Yes':'No'
          row.SDG11= row.SDG11? 'Yes':'No'
          row.SDG12= row.SDG12? 'Yes':'No'
          row.SDG13= row.SDG13? 'Yes':'No'
          row.SDG14= row.SDG14? 'Yes':'No'
          row.SDG15= row.SDG15? 'Yes':'No'
          row.SDG16= row.SDG16? 'Yes':'No'
          row.SDG17= row.SDG17? 'Yes':'No'
          updatedRow= row;
        }
      });


      await API.post("topic", "/topic", {body: updatedRow });
    }
    this.cancelDelete = () => this.setState({ deletingRows: [] });
    this.deleteRows = () => {

      const rows = getStateRows().slice();
      getStateDeletingRows().forEach((rowId) => {
        const index = rows.findIndex(row => row.topic === rowId);
        const topic = rows[index].topic;
        const image_file = rows[index].image;

        //Delete from the database
        API.del("topic", `/topic/${topic}`);

        image_file
        ? s3DeleteThumbnail(image_file)
        : null;

        if (index > -1) {
          rows.splice(index, 1);
        }
      });
      this.setState({ rows, deletingRows: [] });


    };
    this.changeColumnOrder = (order) => {
      this.setState({ columnOrder: order });
    };
  }

    //Call GET topic API
    async componentDidMount() {
      if (!this.props.isAuthenticated) {
        return;
      }
    
      try {
        const rows =  await this.getTopics();
        this.state.category = await this.getCategory();
        availableValues={
            category:  this.state.category.map(a=>a.name),
          }
          console.log(availableValues);

        this.setState({ rows });
        
       } catch (e) {
        alert(e);
      }
  
    }
    
    // make call to Get API

      getTopics() {
      return API.get("topic", "/topic");
    }
  
   getCategory() {
      return API.get("category", "/category");
    }

  render() {
    const {
      classes,
    } = this.props;
    const {
      rows,
      columns,
      sorting,
      editingRowIds,
      addedRows,
      rowChanges,
      currentPage,
      deletingRows,
      pageSize,
      pageSizes,
      columnOrder,
      defaultColumnWidths,
      open
      // currencyColumns,
      // percentColumns,
    } = this.state;

    return (

      <Paper>
          <FormLabel style={{marginLeft:20,  marginTop:40, fontSize: 32, marginBottom:40}}>Animation Topics</FormLabel>

        <Grid
          rows={rows}
          columns={columns}
          getRowId={getRowId}
        >
          <SortingState
            sorting={sorting}
            onSortingChange={this.changeSorting}
          />
          <PagingState
            currentPage={currentPage}
            onCurrentPageChange={this.changeCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={this.changePageSize}
          />
          <FilteringState />

          <IntegratedSorting />
          <IntegratedPaging />
          <IntegratedFiltering />
          {/* <CurrencyTypeProvider for={currencyColumns} />
          <PercentTypeProvider for={percentColumns} /> */}

          <EditingState
            editingRowIds={editingRowIds}
            onEditingRowIdsChange={this.changeEditingRowIds}
            rowChanges={rowChanges}
            onRowChangesChange={this.changeRowChanges}
            addedRows={addedRows}
            onAddedRowsChange={this.changeAddedRows}
            onCommitChanges={this.commitChanges}
          />

          <DragDropProvider />


          <Table
            cellComponent={Cell}
          />

          <TableColumnReordering
            order={columnOrder}
            onOrderChange={this.changeColumnOrder}
          />
          <TableColumnResizing
            defaultColumnWidths={defaultColumnWidths}
          />
          <TableHeaderRow showSortingControls />
          <TableEditRow
            cellComponent={EditCell}
          />
           <TableFilterRow />

          <TableEditColumn
            width={120}
            showAddCommand={!addedRows.length}
            showEditCommand
            showDeleteCommand
            commandComponent={Command}
          />
          <PagingPanel
            pageSizes={pageSizes}
          />
        </Grid>

        <Dialog
          open={!!deletingRows.length}
          onClose={this.cancelDelete}
          classes={{ paper: classes.dialog }}
        >
          <DialogTitle>
            Delete Row
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure to delete the following row?
            </DialogContentText>
            <Paper>
              <Grid
                rows={rows.filter(row => deletingRows.indexOf(row.topic) > -1)}
                columns={columns}
              >
                {/* <CurrencyTypeProvider for={currencyColumns} />
                <PercentTypeProvider for={percentColumns} /> */}
                <Table
                  cellComponent={Cell}
                />
                <TableHeaderRow />
              </Grid>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cancelDelete} color="primary">
                Cancel
            </Button>
            <Button onClick={this.deleteRows} color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            You can modify any other fields except the topic field.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button open ={open} onClick={this.handleClose} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>

      </Paper>
    );
  }
}

export default withStyles(styles, { name: 'topics' })(Topics);

